export default __webpack_public_path__ + "static/media/faceC.110c453a.png";